<template>
  <div>
    <div
      class="limit-online-text"
      v-if="$store.state.plan && ($store.state.plan.group == 'pro'
        || $store.state.plan.group == 'white-label')"
    >
      You can host up to
      <strong>{{ $store.state.plan.limit | formatNumber }}</strong> live participants. Need more?
      <a
        href="https://ahaslides.com/contact-us"
        target="_blank"
      >Contact us</a>.
    </div>

    <div
      class="limit-online-text"
      v-if="$store.state.plan.group != 'pro' && !currentUser.oneTimeEnd
        && $store.state.plan.group != 'white-label'
        && !isGuestUser"
    >
      <span v-if="$store.state.plan.group == 'free'">
        As a free user, you can host up to
        <strong>{{ $store.state.plan.limit | formatNumber }}</strong> live participants.
        <span class="cursor-pointer text-primary-90" @click="goToUpgrade()">
          Upgrade from just $7.95.
        </span>
      </span>
      <span v-else-if="$store.state.plan.group == 'one-time'">
        <span></span>
        You can host up to
        <strong>
          {{ $store.state.plan.limit | formatNumber }}</strong> live participants on your event day
        <i
          class="fas fa-question-circle"
          v-tooltip="oneTimeTooltip"
        />&nbsp;
        <span>
          Need more?
          <a @click="goToUpgrade()">Upgrade now</a>.
        </span>
      </span>
      <span v-else>
        <span></span>
        You can host up to
        <strong>{{ $store.state.plan.limit | formatNumber }}</strong> live participants. Need more?
        <span>
          <a @click="goToUpgrade()">Upgrade now</a>.
        </span>
      </span>
    </div>
    <div
      class="limit-online-text"
      v-if="$store.state.plan.group == 'one-time' && currentUser.oneTimeEnd"
    >
      Your event day has started. You can host up to
      <strong>{{ $store.state.plan.limit | formatNumber }}</strong> live participants until
      <strong>{{ currentUser.oneTimeEnd | dateTimeFirst }}</strong>.
      <br>Need more?
      <a @click="goToUpgrade()">Upgrade now</a>.
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import gaCategories from '@/constant/gaCategories'

// services
import cookie from '@/services/cookie'

export default {
  data() {
    return {
      isGuestUser: !!cookie.getValue('aha-guest-user'),
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
      isNewPresentation: (state) => state.isNewPresentation,
    }),
    oneTimeTooltip() {
      return 'Your event day will start when you have more than 7 participants joining your presentation simultaneously and last for 24 hours'
    },
  },
  methods: {
    goToUpgrade() {
      // add redirect to handle case: guest clicks upgrade -> go to sign-up first
      this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
      utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Click upgrade link on middle')
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.limit-online-text {
  font-size: 13px;
  text-align: center;
  padding-bottom: 12px;
  color: $suva-grey-color;
  max-width: 680px;
  margin: 0 auto;
  font-family: "Nunito", sans-serif;

  a {
    font-weight: bold;
    cursor: pointer;
    color: $primary-color;

    &:hover {
      color: $primary-hover-color;
      text-decoration: underline;
    }
  }
}
</style>
